export interface TermsModel {
  requestChannelCountryCode: string;
  legalLanguage: Array<LegalLanguageModel>,
  requestChannelLegalLanguageNameCode: string;
  requestChannelSourceCode: string;
  statusMessage: string;
  responseDate: string;
  statusCode: string;
}

export interface LegalLanguageModel {
  effectiveEndDate: string;
  legalLanguageType: string;
  languageISOCode: string;
  notificationStatus: string;
  daysRequiredToPostLegalLanguage: string;
  legalLanguageNameCode: string;
  sourceCode: string;
  legalLanguageText: string;
  countryCode: string;
  LLID: string;
  effectiveStartDate: string;
  consentType: string;
  channelName: string;
  legalLanguageName: string;
  FLLID: string;
  fllid: string;
  llid: string;
}